import { Outlet } from "react-router-dom";

export function TaskLayout() {
  return (
    <div className="content-body min-h-screen p-4">
      <div className="mx-auto max-w-2xl">
        <Outlet />
      </div>
    </div>
  );
}
